import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Conditionally load JIT compiler only when running under Capacitor (mobile runtime).
(async () => {
  if ((window as any).Capacitor?.isNativePlatform?.()) {
    await import('@angular/compiler');
  }

  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
